import MediaOwner from "./MediaOwner";
import Advertiser from "./Advertiser";

const pages = {
  MediaOwner,
  Advertiser,
};
export default pages;
